import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scrolls to the top on route change, or to the hash target when one is present. */
export function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}